/* eslint-disable prettier/prettier */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { showToast } from './toastSlice'
import makeRequest from 'src/services/api'
import handleGeneralError from '../helpers/errorHandler'
import { fetchExportListUrl, fetchStatesUrl } from 'src/services/urls'
import { getUniqueListBy } from 'src/lib/utils'

const initialState = {
  loading: false,
  data: { hasMore: false, page: 1, totalDocs: 0, nextPage: 0 },
  docs: [],
  error: '',
  activePage: 0,
  feature: '',
  pageSize: 500,
  states: [],
}

// Fetch loyalty exports list
export const fetchExportList = createAsyncThunk(
  'exports/fetchExportList',
  async (options = {}, { dispatch }) => {
    try {
      const page = options?.page || 1
      const limit = options?.limit || 10
      let docs = []
      let url = fetchExportListUrl() + `?page=${page}&limit=${limit}`
      let filtered = false
      if ('feature' in options && options['feature'] !== '') {
        url = url + `&feature=${options['feature']}`
        filtered = true
      }
      const response = await makeRequest(url)
      if (response.data) docs = response.data.data.docs

      const statesResponse = await makeRequest(fetchStatesUrl())
      return { docs, data: response.data.data, filtered, states: statesResponse?.data?.data }
    } catch (e) {
      handleGeneralError(e, { dispatch, showToast })
      return { error: e?.response?.data?.error?.message }
    }
  },
)

const exportSlice = createSlice({
  name: 'exports',
  initialState,
  reducers: {
    setActivePage: (state, action) => {
      state.activePage = action.payload
    },
    resetExportList: (state) => {
      state.data = { hasMore: false, page: 1, totalDocs: 0, nextPage: 0 }
      state.docs = []
    },
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setFeature: (state, action) => {
      state.feature = action.payload
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload
    },
    setDownloadedSuccess: (state, action) => {
      let index = state.docs.findIndex((d) => d._id == action.payload)
      if (index !== -1) {
        state.docs[index].isDownloaded = true
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchExportList.pending, (state) => {
      state.loading = state.docs.length > 0 ? false : true
    })
    builder.addCase(fetchExportList.fulfilled, (state, action) => {
      state.loading = false
      state.error = action.payload.error
      if (action.payload.docs) {
        state.data = action.payload.data
        const oldData = action.payload.filtered ? [] : state.docs
        const totalData = [...oldData, ...action.payload.docs]
        const uniqueData = getUniqueListBy(totalData, '_id')
        state.docs = uniqueData

        let stateObj = {}
        action.payload.states.forEach((s) => (stateObj[s._id] = s.state))
        state.states = stateObj
      }
    })
    builder.addCase(fetchExportList.rejected, (state, action) => {
      state.loading = false
      state.data = {}
      state.docs = []
      state.error = action.error.message
    })
  },
})

export default exportSlice.reducer
export const {
  setActivePage,
  resetExportList,
  setLoading,
  setFeature,
  setPageSize,
  setDownloadedSuccess,
} = exportSlice.actions
